import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'

import { getDeviceResetTime } from 'src/@api/login'
import dayjs from 'dayjs'
import { disconnectCheck } from 'src/@api/dashboard'

export const fetchResetTime = createAsyncThunk('common/fetchResetTime', async () => {
  let username =
    JSON.parse(localStorage.getItem('DeviceUser')) != null
      ? JSON.parse(localStorage.getItem('DeviceUser')).username
      : ''
  let res = await getDeviceResetTime({ username })

  return {
    basicUpdateDownloadTime:
      res.data.basic_download_time != null ? dayjs(res.data.basic_download_time).format('YYYY-MM-DD HH:mm:ss') : '',
    advancedUpdateDownloadTime:
      res.data.advanced_download_time != null ? dayjs(res.data.advanced_download_time).format('YYYY-MM-DD HH:mm:ss') : '',
    username: username
  }
})

export const advancedShow = createAsyncThunk('common/advancedShow', async () => {
  return true
})

export const fetchDeviceUser = createAsyncThunk('common/fetchDeviceUser', async row => {
  return row
})

export const setCurrentTab = createAsyncThunk('common/setCurrentTab', async value => {
  return value
})

export const getConnectionStatus = createAsyncThunk('common/getConnectionStatus', async () => {
  let username =
    JSON.parse(localStorage.getItem('DeviceUser')) != null
      ? JSON.parse(localStorage.getItem('DeviceUser')).username
      : ''

  const res = await disconnectCheck({
    deviceid: username
  })

  if (res.msg === 'disconnect') {
    return true
  }

  return false
})

export const setConnectionStatus = createAsyncThunk('common/setConnectionStatus', async value => {
  return value
})

export const toggleNavVisibility = createAsyncThunk('common/toggleNavVisibility', async value => {
  return value
})

// 增值服务状态更改
export const changeExtremeService = createAsyncThunk('common/changeExtremeService', async value => {
  return value
})

// 增值服务之前付费用户状态更改
export const changeOldPayingUser = createAsyncThunk('common/changeOldPayingUser', async value => {
  return value
})

// 正在下载提示信息是否弹窗状态更改
export const changeDownloadTips = createAsyncThunk('common/changeDownloadTips', async value => {
  return value
})

// 一步验证完成状态更改
export const changeBasicVerfiyOver = createAsyncThunk('common/changeBasicVerfiyOver', async value => {
  return value
})

export const common = createSlice({
  name: 'Common',
  initialState: {
    advancedShow: false,
    deviceUser:
      typeof window !== 'undefined'
        ? JSON.parse(localStorage.getItem('DeviceUser')) != null
          ? JSON.parse(localStorage.getItem('DeviceUser')).username
          : ''
        : '',
    resetTime: {
      basicUpdateDownloadTime: null,
      advancedUpdateDownloadTime: null
    },
    currentTab: '',
    isDisconnect: false,
    navVisible: false,
    extremeService: true, // 拥有增值服务
    oldPayingUser: false, // 增值服务之前付费用户
    downloadTips: false, // 是否弹窗正在下载提示信息
    basicVerfiyOver: false // 一步验证完成状态更改
  },
  reducers: {},
  extraReducers: builder => {
    builder.addCase(fetchResetTime.fulfilled, (state, action) => {
      state.resetTime = action.payload
      state.deviceUser = action.payload.username
    })
    builder.addCase(advancedShow.fulfilled, (state, action) => {
      state.advancedShow = action.payload
    })
    builder.addCase(fetchDeviceUser.fulfilled, (state, action) => {
      console.log(action.payload, 456)
      state.deviceUser = action.payload
    })
    builder.addCase(setCurrentTab.fulfilled, (state, action) => {
      state.currentTab = action.payload
    })
    builder.addCase(getConnectionStatus.fulfilled, (state, action) => {
      state.isDisconnect = action.payload
    })
    builder.addCase(setConnectionStatus.fulfilled, (state, action) => {
      state.isDisconnect = action.payload
    })
    builder.addCase(toggleNavVisibility.fulfilled, (state, action) => {
      state.navVisible = action.payload
    })
    builder.addCase(changeExtremeService.fulfilled, (state, action) => {
      state.extremeService = action.payload
    })
    builder.addCase(changeOldPayingUser.fulfilled, (state, action) => {
      state.oldPayingUser = action.payload
    })
    builder.addCase(changeDownloadTips.fulfilled, (state, action) => {
      state.downloadTips = action.payload
    })
    builder.addCase(changeBasicVerfiyOver.fulfilled, (state, action) => {
      state.basicVerfiyOver = action.payload
    })
  }
})

export default common.reducer
